module.exports = __webpack_public_path__ + "img/magazin_delo_about_us_1_mob.04e13a94.jpg";